import { v4 } from '@lukeed/uuid';
import { xyIntegration } from 'ml-spectra-processing';
import { getShiftX } from './getShiftX';
function getRange(integral, shiftTarget, shift) {
    const { originalFrom, originalTo, from, to } = integral;
    if (shiftTarget === 'origin') {
        return {
            originalFrom: from - shift,
            originalTo: to - shift,
            from,
            to,
        };
    }
    else {
        return {
            originalFrom,
            originalTo,
            from: originalFrom + shift,
            to: originalTo + shift,
        };
    }
}
export function mapIntegrals(integrals, spectrum, shiftTarget = 'origin') {
    const { x, re } = spectrum.data;
    const shiftX = getShiftX(spectrum);
    return integrals.map((integral) => {
        const integralBoundary = getRange(integral, shiftTarget, shiftX);
        const absolute = xyIntegration({ x, y: re }, { from: integralBoundary.from, to: integralBoundary.to, reverse: true });
        return {
            ...integral,
            id: integral.id || v4(),
            ...integralBoundary,
            absolute,
        };
    });
}
//# sourceMappingURL=mapIntegrals.js.map